var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(-34.431 -34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 24,
    height: 24,
    transform: "translate(34.431 34)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_29-auction",
    "data-name": " 29-auction",
    transform: "translate(35.431 34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M42.667,406.372a1.385,1.385,0,0,1,1.383-1.385H55.115a1.385,1.385,0,0,1,1.383,1.385v1.408H42.667Z",
    transform: "translate(-34.359 -383.78)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M273.667,228.125a5.579,5.579,0,0,1,.926,1.334l-6.57,6.581a.8.8,0,0,1-1.125,0l-1.129-1.131a.8.8,0,0,1,0-1.131h0l6.57-6.579a5.442,5.442,0,0,1,1.332.926Z",
    transform: "translate(-265.535 -215.444)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M136.558,93.862a8.925,8.925,0,0,0,2.66,1.709L133.9,100.9a9.086,9.086,0,0,0-1.708-2.663,8.929,8.929,0,0,0-2.66-1.709L134.85,91.2A9.093,9.093,0,0,0,136.558,93.862Z",
    transform: "translate(-123.039 -86.577)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M2.066,10.3A2.056,2.056,0,0,0,4.124,8.238L4.119,2.06A2.06,2.06,0,1,0,0,2.06L.007,8.234A2.063,2.063,0,0,0,2.066,10.3Z",
    transform: "translate(4.791 10.197) rotate(-135)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M2.066,10.3A2.056,2.056,0,0,0,4.124,8.238L4.119,2.06A2.06,2.06,0,1,0,0,2.06L.007,8.234A2.063,2.063,0,0,0,2.066,10.3Z",
    transform: "translate(13.522 18.941) rotate(-135)",
    fill: "#fac668"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.a2e153a1.svg";
export { ForwardRef as ReactComponent };